// generated from 13_976 samples

import { z } from "zod";
import { common } from "../common";
import { stepGetBaseSchema } from "./stepGetBaseSchema";

export const audienceSyncStepGetSchema = z.object({
  ...stepGetBaseSchema.shape,
  type: z.literal("AUDIENCE_SYNC"),
  step_data: z.object({
    app_group_id: common.objectId,
    audience_syncs: z.array(
      z.object({
        action: z.enum([
          "add_users", // 11_965 (65.00%)
          "remove_users", // 3_890 (21.13%)
          "", // 2_554 (13.87%)
        ]),
        // format integer: 14_468 (78.59%)
        adAccountId: z.string(),
        adAccountName: z.null(),
        as_id: common.uuid,
        // null: 4 (0.02%)
        // format integer: 9_586 (52.08%)
        customAudienceId: z.string().nullable(),
        customAudienceName: z.string(),
        partner: z.enum([
          "facebook", // 7_525 (40.88%)
          "google", // 5_754 (31.26%)
          "", // 2_652 (14.41%)
          "tiktok", // 1_283 (6.97%)
          "snapchat", // 553 (3.00%)
          "pinterest", // 361 (1.96%)
          "criteo", // 214 (1.16%)
          "linkedin", // 67 (0.36%)
        ]),
        selectedFields: z.array(
          z.enum([
            "email", // 13_826 (26.99%)
            "phone", // 10_773 (21.03%)
            "first_name", // 4_487 (8.76%)
            "last_name", // 4_398 (8.58%)
            "country", // 3_393 (6.62%)
            "mobile_id", // 3_306 (6.45%)
            "city", // 3_240 (6.32%)
            "date_of_birth", // 2_832 (5.53%)
            "gender", // 2_822 (5.51%)
            "android_gaid", // 1_210 (2.36%)
            "ios_idfa", // 945 (1.84%)
          ])
        ),
      })
    ),
    bulk_flusher_rate_limit_violations: z.array(
      // true 62 (0.34%), false 18_347 (99.66%)
      z.boolean()
    ),
    canvas_id: common.objectId,
  }),
});
